import { useMetricRamQuery } from "@/common/api/metric/use-metric-ram.query";
import { MetricCard } from "@/components/dashboard/cards/metric-card";
import { AppWindowIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ApplicationMetric() {
  const { t } = useTranslation(["ram", "common"]);
  const { data, isLoading } = useMetricRamQuery();

  return (
    <MetricCard icon={AppWindowIcon} label={t("common:Apps")} value={data?.applicationCount ?? 0} loading={isLoading} />
  );
}
